// [H_UIPOLISH_V1_L4] AyaAsset — Registry centralisé des assets PNG custom.
// ─────────────────────────────────────────────────────────────────────────────
// Polish-only. Sert UNIQUEMENT à afficher des images statiques avec lazy-load,
// alt obligatoire, et un mapping logique → URL. Aucun comportement.
// ─────────────────────────────────────────────────────────────────────────────

import React from "react";

const REGISTRY = {
    // Avatars
    "avatar.konan": "/aya/avatars/konan_awa.png",
    // Illustrations
    "merchant.tantie_adjoua": "/aya/illustrations/merchant_tantie_adjoua.png",
    "wallet.card_3d": "/aya/illustrations/wallet_card_3d.png",
    // Heroes
    "hero.maquis": "/aya/heroes/maquis_tropical.png",
    "hero.supermarket": "/aya/heroes/supermarket_abidjan.png",
    // Icons (grille 3×2 — legacy sprite, conservé pour rétrocompat)
    "icons.transactions_set": "/aya/icons/transactions_set.png",
    // Icons V2 — fichiers individuels (refonte L4 finale)
    "icon.restaurant":  "/aya/icons/restaurant.png",
    "icon.supermarket": "/aya/icons/supermarket.png",
    "icon.transfer":    "/aya/icons/transfer.png",
    "icon.rent":        "/aya/icons/rent.png",
    "icon.telecom":     "/aya/icons/telecom.png",
    "icon.fuel":        "/aya/icons/fuel.png",
    // Patterns
    "pattern.wax": "/aya/patterns/wax_subtle.png",
    // UI
    "ui.typing": "/aya/ui/chat_typing_indicator.png",
};

// Position dans la grille 3×2 (col, row). Utilisé par AyaAssetTxIcon.
const TX_ICON_GRID = {
    restaurant: { col: 0, row: 0 },
    supermarket: { col: 1, row: 0 },
    transfer: { col: 2, row: 0 },
    rent: { col: 0, row: 1 },
    telecom: { col: 1, row: 1 },
    fuel: { col: 2, row: 1 },
};

export default function AyaAsset({
    name,
    alt = "",
    className = "",
    style = {},
    rounded = false,
    ...rest
}) {
    const src = REGISTRY[name];
    if (!src) {
        if (process.env.NODE_ENV !== "production") {
            // eslint-disable-next-line no-console
            console.warn(`[AyaAsset] unknown name: ${name}`);
        }
        return null;
    }
    return (
        <img
            src={src}
            alt={alt}
            loading="lazy"
            decoding="async"
            className={`aya-asset ${rounded ? "aya-asset-rounded" : ""} ${className}`.trim()}
            style={style}
            data-aya-asset={name}
            {...rest}
        />
    );
}

/**
 * Affiche une icône de transaction.
 * Refonte L4 : utilise désormais les PNG individuels via REGISTRY["icon.{kind}"].
 * `TX_ICON_GRID` reste exporté pour rétrocompat (info géométrique).
 */
export function AyaAssetTxIcon({ kind = "restaurant", size = 40, className = "", style = {} }) {
    const src = REGISTRY[`icon.${kind}`] || REGISTRY["icon.restaurant"];
    return (
        <img
            src={src}
            alt={`tx-icon-${kind}`}
            loading="lazy"
            decoding="async"
            data-aya-tx-icon={kind}
            className={`aya-asset aya-tx-icon ${className}`.trim()}
            style={{
                display: "inline-block",
                width: size,
                height: size,
                objectFit: "cover",
                borderRadius: "var(--aya-radius-md)",
                ...style,
            }}
        />
    );
}

export { REGISTRY as AYA_ASSET_REGISTRY, TX_ICON_GRID };
